export default __webpack_public_path__ + "static/media/AdGhosts_02.bb309584.png";